module.exports = __webpack_public_path__ + "static/img/print-4.7a6b998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/print-4.png
// module id = 1tDI
// module chunks = 10